import React, { Component } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, kmFormatter } from "../utils";

class TopicWisePlatformAnalysisChart extends Component {
    constructor(props) {
        super(props);
        this.chartComponent = React.createRef();
    }
    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextProps.expandWidget !== this.props.expandWidget ||
            // nextProps.currentChartType !== this.props.currentChartType ||
            nextProps.showLegend !== this.props.showLegend ||
            nextProps.showLabel !== this.props.showLabel ||
            nextProps.showGridLines !== this.props.showGridLines
            // nextProps.index !== this.props.index
        ) {
            return true;
        }

        return false;
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }
    getBarOptions = () => {
        let chartConfig = {};
        let data = JSON.parse(JSON.stringify(this.props.data));
        let self = this;
        let chartData;
        if (this.props.expandWidget) {
            chartData = JSON.parse(JSON.stringify(data.maximizeStackedBarData));
        } else {
            chartData = JSON.parse(JSON.stringify(data.chartDataBar));
        }

        chartData.map((d, i) => {
            if (i > 5) {
                d.visible = false;
            } else {
                d.visible = true;
            }
        });

        chartConfig = {
            chart: {
                type: "bar",
                className: "skiptranslate",
                //backgroundColor: "transparent",
                backgroundColor: "transparent",
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                scrollablePlotArea: {
                    minHeight:
                        this.props.expandWidget && data.maximizeStackedBarData[0].data.length > 15
                            ? data.maximizeStackedBarData[0].data.length * 30
                            : data.chartDataBar[0].data.length,
                    opacity: 1,
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },
            xAxis: {
                type: "category",
                lineWidth: 1,
                labels: {
                    formatter: function () {
                        let value = this.value.length > 20 ? this.value.substring(0, 20) + "..." : this.value;
                        return value;
                    },
                },
            },
            yAxis: {
                reversedStacks: false,
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                min: 0,
                max: 100,
                title: {
                    text: ``,
                },
                labels: {
                    format: "{text}%",
                },
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    minPointLength: 8,
                    stacking: "percent",
                    dataLabels: {
                        enabled: this.props.showLabel,
                        formatter: function () {
                            return kmFormatter(this.y);
                        },
                        style: {
                            color: "#333333",
                            textOutline: "none",
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                    // events: {
                    //     legendItemClick: function () {
                    //         if (this.visible) {
                    //             this.setData([], false);
                    //         } else {
                    //             this.setData(chartData[this.index].data, false);
                    //         }
                    //     },
                    // },

                    events: {
                        legendItemClick: function () {
                            self.props.legendClick(true);
                        },
                    },
                },
            },
            legend: {
                // enabled: this.props.showLegend,
                // width: "20%",
                // layout: "vertical",
                // align: "right",
                // padding: 3,
                // itemMarginTop: 3,
                // itemMarginBottom: 3,
                // verticalAlign: "middle",
                // // x: 50,
                // alignColumns: true,
                // itemStyle: {
                //     fontWeight: 500,
                //     textTransform: "normal",
                //     fontFamily: "'Roboto', sans-serif",
                // },

                enabled: this.props.showLegend,
                // width: "20%",
                // layout: "vertical",
                // align: "right",
                // padding: 3,
                // itemMarginTop: 3,
                // itemMarginBottom: 3,
                // verticalAlign: "middle",
                // alignColumns: true,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series: chartData,
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                useHTML: true,
                shared: this.props.expandWidget ? true : false,
                headerFormat: this.props.expandWidget && `<span><b>{point.key}</span><br />`,
                pointFormatter: function () {
                    let toolTipData = "";
                    let topicTotal = this.topic_total;
                    if (topicTotal != 0 && this.y != 0) {
                        toolTipData += `<span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:0px 1px;">
                        <span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;">
                         <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${
                             this.series.color
                         };border-radius:10px" ></span> <span style="display:inline-block;width:114px;">${
                            this.series.name
                        } </span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"><b> ${
                            ((this.y * 100) / topicTotal).toFixed(1) + "%"
                        }</b> </span> <span style="display:inline-block;padding:1px"><b>(${numberWithCommas(this.y)} / ${numberWithCommas(
                            topicTotal,
                        )})</b> </span><br/> </span>`;
                    }
                    return toolTipData;
                },

                formatter:
                    !this.props.expandWidget &&
                    function () {
                        let topicTotal = this.point.options.topic_total;
                        return `${this.key} | ${this.series.name} | <b>${((this.y * 100) / topicTotal).toFixed(1) + "%"}</b> | <b>${numberWithCommas(
                            this.y,
                        )}/${numberWithCommas(topicTotal)}</b>`;
                    },
            },
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 500,
                        },
                        chartOptions: {
                            legend: {
                                labelFormatter: function () {
                                    let name = this.name.length > 12 ? this.name.substring(0, 12) + "..." : this.name;
                                    return name;
                                },
                            },
                            xAxis: {
                                labels: {
                                    formatter: function () {
                                        let value = this.value.length > 12 ? this.value.substring(0, 12) + "..." : this.value;
                                        return value;
                                    },
                                },
                            },
                        },
                    },
                ],
            },
        };
        return chartConfig;
    };

    render() {
        return (
            <>
                {this.props.currentChartType === "bar" && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getBarOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                    />
                )}
            </>
        );
    }
}
export default TopicWisePlatformAnalysisChart;
